import {
  Computer,
  CircuitBoard,
  Zap,
  Wrench,
  Landmark,
  DraftingCompass,
  Car,
  Building, // Default icon
} from 'lucide-react';

export const departmentIcons = {
  'computer-engineering': Computer,
  'electronics-engineering': CircuitBoard,
  'electrical-engineering': Zap,
  'mechanical-engineering': Wrench,
  'civil-engineering': Landmark,
  'architectural-engineering': DraftingCompass,
  'automobile-engineering': Car,
};

export const DefaultIcon = Building;
